webpackJsonp([162898551421021],{

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Layout = __webpack_require__(14);
	
	var _Footer = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFound = function NotFound() {
	  return _react2.default.createElement(
	    _Layout.Box,
	    null,
	    _react2.default.createElement(
	      _Layout.Box,
	      {
	        width: [1, 1, 1 / 2],
	        m: ['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto'],
	        px: [3, 3, 0]
	      },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Site not found'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Sorry, this might be a broken link. Please report to webmaster@chi.camp.'
	      )
	    ),
	    _react2.default.createElement(_Footer.Footer, null)
	  );
	}; /* eslint-disable */
	exports.default = NotFound;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-f92674c5a9e950b37630.js